import GreenTrashIcon from 'assets/icons/delete-green.svg';

interface ModalFooterProps {
  onDelete: () => void;
  onApply: () => void;
}

const ModalFooter = ({ onDelete, onApply }: ModalFooterProps) => {
  return (
    <div className='flex items-center justify-end gap-8 px-8 py-6'>
      <button
        onClick={onDelete}
        className='text-lg flex items-center gap-1 text-green-700 dark:text-green-400'
      >
        <img src={GreenTrashIcon} alt='delete' />
        Delete Data
      </button>
      <button
        onClick={onApply}
        className='text-lg px-[20px] h-[40px] flex items-center bg-black dark:bg-white text-white dark:text-black hover:bg-gray-850 dark:hover:bg-gray-200 rounded-full transition-colors'
      >
        Apply
      </button>
    </div>
  );
};

export default ModalFooter;
